import React from 'react';
import { Card } from 'react-bootstrap';
import { SkeletonTable } from '../../../components/Skeleton/Table';
import FiltersLoading from '../components/FiltersLoading';

const Loading: React.FC = () => (
  <Card>
    <Card.Header>
      <FiltersLoading />
    </Card.Header>
    <SkeletonTable className="card-table" columns={7} rows={4} />
  </Card>
);

export default Loading;
